import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-invoice-generation',
  templateUrl: './invoice-generation.component.html',
  styleUrls: ['./invoice-generation.component.scss']
})
export class InvoiceGenerationComponent implements OnInit {

  IsHaveTable: boolean = false;
  customerInvoiceList: any[] = [];
  transdate: string;
  theirref: string;
  ourref: string;
  otp: string;
  showOtpComponent = true;
  @ViewChild('ngOtpInput', { static: false})
  ngOtpInput: any;
  @ViewChild("myinput") myInputField: ElementRef;
  config = {
    allowNumbersOnly: true,
    length: 7,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };



  constructor(
    private fb: FormBuilder,
    private lookupDataService: LookupDataServiceService,
    private reportService: ReportService,
    private toastr: NotificationService,

  ) { }
  invoiceGeneration: FormGroup;
  ngOnInit(): void {
    this.initializeValidators();
  }

  ngAfterViewInit() {
    this.myInputField.nativeElement.focus();
  }

  onOtpChange(otp) {
    this.otp = otp;
    // if (this.otp.length == 7) {
    //   this.generateInvoice(this.otp);
    // }

  }
  initializeValidators() {
    console.log('inside line 179');

    this.invoiceGeneration = this.fb.group({
        invoiceNumber: ['',Validators.required,],
    //   landLineNumberlabel: new FormControl({
    //     value: null,
    //     disabled: true,
    //   }, [Validators.required]),

    });
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 48 && event.charCode <= 57;
  }

  displayErrorMsg(flag: number, invoiceNumber: string) {
    var message = '';
    if (flag == 1) {
      message = "Enter Invoice Number"

      Swal.fire({
        //position: 'top-center',
        icon: 'error',
        title: message,
        //html: true,
        showConfirmButton: true,
        position: 'center', // Set the position to 'center'

      }).then((res: any) => {
        if (res.isConfirmed) {
          Swal.close();

        }
      })

    } else if (flag == 0) {
      message = "Invoice Number " + invoiceNumber + " not exist"

      Swal.fire({
        //position: 'top-center',
        icon: 'error',
        title: message,
        //html: true,
        showConfirmButton: true,
        position: 'center', // Set the position to 'center'

      }).then((res: any) => {
        if (res.isConfirmed) {
          Swal.close();

        }
      })

    }


  }

  generateInvoice() {
    debugger
    if (!this.invoiceGeneration.valid) {
        this.invoiceGeneration.markAllAsTouched();
        this.toastr.showError("Please fill in all mandatory fields")
        return;
    }
    else {  
      this.lookupDataService.getCustomerInvoiceByInvoiceNo(this.invoiceGeneration.value.invoiceNumber)
        .subscribe(result => {
          debugger
          if (result == "invalid") {
            this.IsHaveTable = false;
            this.displayErrorMsg(0,this.invoiceGeneration.value.invoiceNumber);
          } else {
            if (result.length == 0) {
              this.IsHaveTable = false;
              this.displayErrorMsg(0,this.invoiceGeneration.value.invoiceNumber);
            } else {
              this.IsHaveTable = true;
              this.customerInvoiceList = result;

              this.customerInvoiceList.forEach(element => {
                if (element.customerID.value == null) {
                  element.customerID.value = "";
                }
                if (element.description.value == null) {
                  element.description.value = "";
                }
                element.description.value = element.customerID.value + " - " + element.description.value;
              });

              this.transdate = new Date(this.customerInvoiceList[0].date.value).toISOString().split('T')[0];
              this.theirref = this.customerInvoiceList[0].description.value;
              this.ourref = this.customerInvoiceList[0].referenceNbr.value;
            }
          }
        });
    }
    //  else {
    //   this.IsHaveTable = false;
    //   this.displayErrorMsg(1, this.invoiceGeneration.value.invoiceNumber);
    // }
  }

  searchreset() {
    this.customerInvoiceList = [];
    this.IsHaveTable = false;
    this.transdate = null;
    this.theirref = null;
    this.ourref = null;
    this.invoiceGeneration.get('invoiceNumber').patchValue('');
    this.invoiceGeneration.controls['invoiceNumber'].markAsUntouched();
  }

  downLoadInvoiceBatch() {

    let data = {
      ourref: this.ourref,

    }
    this.reportService.getCustomerInvoiceReportByInvoiceNo(data).subscribe(res => {
      if (res) {
        const linkSource = 'data:application/pdf;base64, ' + res;
        const downloadLink = document.createElement('a');
        const fileName = `${this.ourref} - Invoice Report.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      }
      this.toastr.showSuccess(`Invoice report downloaded successfully`);
    });
  }


}
